import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SessionModule from './session';
import { Settings } from '~/services/settings';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public session!: SessionModule;

    public eligibilityData = [] as SurveySessionValueModel[];

    public isEligible = false;
    public checkbox = false as boolean;
    public agreeToTextMessageConsent = false as boolean;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Mutation
    public async addEligiblityData(model: SurveySessionValueModel) {
        this.eligibilityData.push(model);
    }

    @Action({ rawError: true })
    public async clearStore() {
        this.updateEligibilityData([]);
        this.updateIsEligible(false);
        this.updateTermsCheckbox(false);
    }

    @Action({ rawError: true })
    public checkEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        const correctAnswers = [
            +this.settings.patientCommercialInsuranceYes,
            +this.settings.patientFedralNo,
           // +this.settings.patintPayingCashNo,
            +this.settings.patientCurrentTerritoryYes,
            +this.settings.patientAgeYes,
        ] as number[];

        const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
        this.updateIsEligible(isEligible);
        return isEligible;
    }

    getPath(){
        return localStorage.getItem('path');
    }

    @Mutation
    public async updateTermsCheckbox(value: boolean) {
        this.checkbox = value;
    }

    @Mutation
    public async updateTextTermsCheckbox(value: boolean) {
        this.agreeToTextMessageConsent = value;
    }

}
